module.exports = __webpack_public_path__ + "img/embargo time.b3af347d.svg";